import React, { Component } from 'react';
import { LanguageField } from '../../Components';
import { otherApi, bmoApi, postApi } from '../../../api'
import Layout from '../../Layouts/DefaultLayout'
import HomeBanner from '../../Layouts/Partials/HomeBanner.js'
import OfferingCarousel from '../../Layouts/Partials/OfferingCarousel.js'
import ResourcesCarousel from '../../Layouts/Partials/ResourcesCarousel.js'
import OperatorsCarousel from '../../Layouts/Partials/OperatorsCarousel.js';
import VideosCarousel from '../../Layouts/Partials/VideosCarousel.js';  //Video Slider
import Newsletter from '../../Layouts/Partials/NewsletterForm.js';
import Slider from "react-slick";  //Video Slider
import { Container, Row, Col } from 'react-bootstrap'
import  '../../Styles/css/home.css'; 
import { partnerApi } from '../../../api'; //added to call partner api  /*Separate Partners from Operators Filter*/
import { async } from 'q'; //added additional import    /*Separate Partners from Operators Filter*/

class HomeView extends Component {

    constructor(props) {
        super();
        this.state = {
            partnerobj:[] //added to store partner data /*Separate Partners from Operators Filter*/
        }
    }

    componentDidMount = async () => {

    }

    /*Separate Partners from Operators Filter*/
    componentWillMount = async () => {
        await this.setPartnersdata();
     }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.isLoading_auth === true && nextProps.isLoading_auth === false) {
            this._initialData();
        }
        return true;
    }

    //added async and await /*Separate Partners from Operators Filter*/
    _initialData = async() => {
        await otherApi.fetchGeneralData().then(res => {
            this.setState(res.data)
        })
        await postApi.searchPosts(this.props.token, 1, { posts_per_page: 8, env: process.env.REACT_APP_MODE, 'post-type': 'post' }).then(res => res.json()).then(json => {
            this.setState({ latest_resources: json.data })
        })
        await bmoApi.searchBMOs(this.props.token, 1, { posts_per_page: 200, env: process.env.REACT_APP_MODE, 'post-type': 'bmo' }).then(res => res.json()).then(json => {
            this.setState({ operators: json.result })
        })
    }

    //To fetch Partners data    /*Separate Partners from Operators Filter*/
    setPartnersdata = async() =>{
        let partnerdata = [];
        let partnersformdata = {
            "posts_per_page": 1000,
            "posts_status": ["publish"]
        }

    const partnersapiResponse =   await partnerApi.searchPartners(this.props.token, 1, partnersformdata);
    const partnersrespJson = await partnersapiResponse.json();
    if(partnersapiResponse.status === 200)
    {
        let partnerresultobj = {};
        partnerresultobj['result'] = partnersrespJson['data'];
        
        partnerresultobj['result'].map((data,index) => {
            const {post_title} = data
            partnerdata.push(post_title.toLowerCase());
        });
        this.state.partnerobj = partnerdata;
        this.removepartnerbridge();
    }
}

//To remove bridge and partner from Bmos    /*Separate Partners from Operators Filter*/
removepartnerbridge()
{
    if(this.state.operators != undefined)
    {
        let bmos_partners_index =[];   //code to remove partners from bmos array
        this.state.operators.map((operatordata,bmoindex) => {
            const {name} = operatordata

           //Commented -to fix remove bridge index after partners removal from bmos array
           /*
            if(name.toLowerCase().startsWith('bridge') == true)
            {
                this.state.operators.splice(bmoindex,1);
            }
            */

            for (var i = 0; i < this.state.partnerobj.length; i++) {
            if(name.toLowerCase().startsWith(this.state.partnerobj[i]) == true)
            {
               // this.state.operators.splice(bmoindex,1);  //code to remove partners from bmos array
               bmos_partners_index.push(bmoindex);  //code to remove partners from bmos array
               break;                              //code to remove partners from bmos array
            }
        }
        });

        //code to remove partners from bmos array
        for(var r=bmos_partners_index.length-1; r>=0; r--)
        {
            this.state.operators.splice(bmos_partners_index[r],1);
        }
        //code to remove partners index in bmos array

        //Code to remove bridge from bmos array
        this.state.operators.map((data,bridgeindex) => {
        const {name} = data
        if(name.toLowerCase().startsWith('bridge') == true)
        {
            this.state.operators.splice(bridgeindex,1);
        }
        });
    }
}



    render = () => {
        const banners = this.state.banners ? this.state.banners.edges : []
        const banners1 = this.state.banners ? this.state.banners.edges : []

        //const pageContent = this.state.pages ? this.state.pages.edges[0].node.content : ""  //commented for Video Slider
        
        const videoContent = this.state.pages ? this.state.pages.edges : [] //Video Slider
        
        const resources = this.state.latest_resources || []
        const industries = this.state.industries ? this.state.industries.edges : []
        {this.removepartnerbridge()}  //added for remove partner and bridge from bmos   /*Separate Partners from Operators Filter*/
        const operators = this.state.operators || []

        const str = this.props.useremail;
        if(
            str.toLowerCase().includes('softbank') || str.toLowerCase().includes('stc') ||
            str.toLowerCase().includes('chinatelecomglobal') || str.toLowerCase().includes('gmail') || 
            str.toLowerCase().includes('solutions.com.kw')
          )
        {

        //To display first banner image only
        banners1.map( (banner,index) => {
            if(index == 1)
            {
            banners1.splice(index)
            }
        })

        return (
            <Layout>
                <HomeBanner banners={banners1} />
                <OperatorsCarousel data={this.state.operators || []} /> 
                    {/*
                    <OfferingCarousel token={this.props.token} industries={industries} />
                    
                    <VideosCarousel data={videoContent || []} /> 
                    */}
                <Newsletter />
            </Layout>
        );
            }
            else
            {
                return (
                    <Layout>
                        {/*Comments: 5G Initial Code Changes, Modified By: <Asar>, Date Modified: <2020-01-22> */}
                        <HomeBanner banners={banners} />
                                       
                        <OfferingCarousel token={this.props.token} industries={industries} />
                        {/*<ResourcesCarousel data={resources} />*/}
                        {/*Comments: 5G Initial Code Changes, Modified By: <Asar>, Date Modified: <2020-01-22>
                        <OperatorsCarousel data={operators} />
                        */}
                        <OperatorsCarousel data={this.state.operators || []} />  {/*added for send the updated operators*/} {/*Separate Partners from Operators Filter*/}
                        
                       
                        <VideosCarousel data={videoContent || []} /> 
        
                        {/*
                        <Container className="my-5 home-content">
                            <div className="home-div" dangerouslySetInnerHTML={{ __html: pageContent }}></div>
                        </Container>
                        */}
                        <Newsletter />
                    </Layout>
                );
            }
    };



}


/* Export Component ==================================================================== */
export default HomeView;